import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshmark-make-a-deal-days';

export default function Example() {
  return (
    <>
      <Head>
        <title>How to Make More Money With Poshmark Make a Deal Days</title>
        <meta
          name='description'
          content="Here's how you can get your name out to the community and get noticed by buyers by winning big and getting more offers out to likers on Poshmark with Make a Deal Days."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-make-a-deal-days' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-make-a-deal-days' />
        <meta property='og:title' content='How to Make More Money With Poshmark Make a Deal Days' />
        <meta
          property='og:description'
          content="Here's how you can get your name out to the community and get noticed by buyers by winning big and getting more offers out to likers on Poshmark with Make a Deal Days."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-08-31T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-08-31T00:00:00-00:00' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
